// extracted by mini-css-extract-plugin
module.exports = {"link":"_93444fe79c--link--14PhO","link-simplified":"_93444fe79c--link-simplified--13isd","title":"_93444fe79c--title--3CbJG"};